import { CONDITIONAL_VARIABLE_NAMES } from '@/helpers/consts';
const LINK_ICON = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6760_11933)">
<path
    d="
        M3.14756 5.80666
        C3.50756 5.42978 4.10311 5.43778 4.472 5.80666
        C4.82578 6.14444 4.84 6.68844 4.53689 7.05911
        L4.472 7.132
        L2.88889 8.71511
        C2.23911 9.36489 1.87556 10.2191 1.87556 11.1347
        L1.88 11.3036
        C1.92 12.0867 2.23378 12.8387 2.77067 13.4298
        L2.88889 13.5542
        L2.88978 13.5551
        C4.21689 14.8982 6.38311 14.8991 7.728 13.5542
        L7.72889 13.5533
        L9.31289 11.9871
        C9.67467 11.6084 10.2667 11.6236 10.648 11.9836
        C11.0302 12.3436 11.0231 12.9427 10.6524 13.3133
        L9.06933 14.8964
        C8.03111 15.9338 6.65956 16.4431 5.30844 16.4431
        C3.95556 16.4431 2.60178 15.9338 1.56444 14.8964
        C0.608889 13.956 0.0702222 12.7071 0.00622222 11.3978
        L0 11.1347
        C0 9.72755 0.563556 8.39067 1.56444 7.39066
        L3.14756 5.80666

        Z

        M10.6427 4.49378
        C11.0027 4.116 11.5982 4.12489 11.9671 4.49378
        L12.0293 4.56311
        C12.3022 4.89911 12.3022 5.39511 12.0293 5.73111
        L11.9671 5.80044
        L5.81956 11.948
        C5.66133 12.1062 5.45422 12.1924 5.24622 12.2111
        L5.15733 12.2156
        C4.92 12.2156 4.67556 12.1293 4.49511 11.948
        C4.11822 11.588 4.12622 10.9924 4.49511 10.6236
        L10.6427 4.49378

        Z

        M7.392 1.54444
        C9.46667 -0.511559 12.8231 -0.511559 14.8969 1.54444
        L14.8996 1.54711
        C15.8987 2.56489 16.4444 3.884 16.4444 5.29022
        C16.4444 6.60844 15.9653 7.86533 15.08 8.84311
        L14.8978 9.03511
        L13.3147 10.6173
        C13.1564 10.7756 12.9493 10.8618 12.7413 10.8804
        L12.6516 10.8849
        C12.4142 10.8849 12.1707 10.7987 11.9893 10.6173
        C11.6124 10.2573 11.6213 9.66178 11.9893 9.29289
        L13.5724 7.71066
        C14.2053 7.06 14.5689 6.20578 14.5689 5.29022
        C14.5689 4.372 14.2204 3.52044 13.5733 2.87244
        C12.2276 1.54266 10.0604 1.54266 8.71556 2.87244
        L7.13244 4.45377
        L7.13156 4.45289
        C6.77333 4.82889 6.18133 4.82178 5.81244 4.45733
        C5.43111 4.09733 5.43822 3.49911 5.808 3.12933
        L7.392 1.54444
        Z
    "
    fill="#213F6B"/>
</g>
</svg>`;
const HTML_LINK_PATTERN = /<a\b[^>]*\bhref=(["'])(.*?)\1[^>]*>(.*?)<\/a>/gis;
export const isConditionalVariable = (variableName) => {
    return CONDITIONAL_VARIABLE_NAMES.includes(variableName);
};
export const escapeHtml = (value) => {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
};
const decodeHtml = (value) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
};
const stripHtml = (value) => {
    const container = document.createElement('div');
    container.innerHTML = value;
    return container.textContent || '';
};
const escapeHtmlAttribute = (value) => {
    return escapeHtml(value);
};
export const serializeEditorLink = (text, url) => {
    const safeText = escapeHtml(text.trim());
    const safeUrl = escapeHtmlAttribute(url.trim());
    return (`<a href="${safeUrl}" ` +
        `target="_blank" ` +
        `rel="noopener noreferrer">` +
        `${safeText}</a>`);
};
export function extractLinksFromHtml(html) {
    if (!html) {
        return [];
    }
    const document = new DOMParser().parseFromString(html, 'text/html');
    return Array.from(document.querySelectorAll('a'))
        .map((link) => ({
        url_content: link.getAttribute('href')?.trim() ?? '',
        text_content: link.textContent?.trim() ?? '',
    }))
        .filter(link => Boolean(link.url_content) &&
        Boolean(link.text_content));
}
export function collectEmailTemplateLinks(contents) {
    return contents.flatMap(extractLinksFromHtml);
}
export const getEditorHtml = (value) => {
    const links = [];
    const valueWithLinkPlaceholders = value.replace(HTML_LINK_PATTERN, (match, quote, rawUrl, rawText) => {
        const index = links.length;
        const placeholder = `__EDITOR_LINK_${index}__`;
        links.push({
            placeholder,
            url: decodeHtml(rawUrl),
            text: decodeHtml(stripHtml(rawText)),
        });
        return placeholder;
    });
    const escapedValue = escapeHtml(valueWithLinkPlaceholders)
        .replace(/\n/g, '<br>');
    const htmlWithLinks = links.reduce((result, link) => {
        const safeText = escapeHtml(link.text);
        const safeUrl = escapeHtmlAttribute(link.url);
        const chipHtml = (`<span ` +
            `class="b-email-template-builder-page__link-chip" ` +
            `contenteditable="false" ` +
            `role="link" ` +
            `tabindex="0" ` +
            `data-link-text="${safeText}" ` +
            `data-link-url="${safeUrl}">` +
            `<span class="b-email-template-builder-page__link-chip-icon">${LINK_ICON}</span>` +
            `<span class="b-email-template-builder-page__link-chip-text">${safeText}</span>` +
            `</span>`);
        return result.replace(link.placeholder, chipHtml);
    }, escapedValue);
    return htmlWithLinks.replace(/{{\s*([\w_]+)\s*}}/g, (match, variableName) => {
        const conditionalClass = isConditionalVariable(variableName) ?
            ' m-conditional' :
            '';
        return (`<span ` +
            `class="b-email-template-builder-page__variable-chip${conditionalClass}" ` +
            `contenteditable="false" ` +
            `data-variable="${variableName}">` +
            `${variableName}` +
            `<span ` +
            `class="b-email-template-builder-page__variable-chip-close" ` +
            `data-remove-variable="true">×</span>` +
            `</span>`);
    });
};
const extractNodeValue = (editor) => {
    const result = [];
    const walk = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
            result.push(node.textContent || '');
            return;
        }
        if (node.nodeType !== Node.ELEMENT_NODE) {
            return;
        }
        const element = node;
        if (element.dataset.linkText &&
            element.dataset.linkUrl) {
            result.push(serializeEditorLink(element.dataset.linkText, element.dataset.linkUrl));
            return;
        }
        if (element.dataset.variable) {
            result.push(`{{ ${element.dataset.variable} }}`);
            return;
        }
        if (element.tagName === 'BR') {
            result.push('\n');
            return;
        }
        Array.from(element.childNodes).forEach(walk);
        if (element.tagName === 'DIV' ||
            element.tagName === 'P') {
            result.push('\n');
        }
    };
    Array.from(editor.childNodes).forEach(walk);
    return result.join('');
};
export const extractEditorRawValue = (editor) => {
    return extractNodeValue(editor);
};
export const extractEditorValue = (editor) => {
    return extractNodeValue(editor)
        .replace(/\n{3,}/g, '\n\n')
        .trim();
};
export const getCaretTextPosition = (editor, range) => {
    const rangeBeforeCaret = range.cloneRange();
    rangeBeforeCaret.selectNodeContents(editor);
    rangeBeforeCaret.setEnd(range.startContainer, range.startOffset);
    const container = document.createElement('div');
    container.appendChild(rangeBeforeCaret.cloneContents());
    return extractEditorRawValue(container).length;
};
export const getRangeByTextPosition = (editor, position) => {
    let currentPosition = 0;
    let resultRange = null;
    const createRange = (node, offset) => {
        const range = document.createRange();
        range.setStart(node, offset);
        range.collapse(true);
        resultRange = range;
    };
    const createRangeAfterElement = (element) => {
        const parent = element.parentNode || editor;
        const offset = Array
            .from(parent.childNodes)
            .indexOf(element) + 1;
        createRange(parent, offset);
    };
    const walk = (node) => {
        if (resultRange) {
            return;
        }
        if (node.nodeType === Node.TEXT_NODE) {
            const textLength = node.textContent?.length || 0;
            if (currentPosition + textLength >=
                position) {
                createRange(node, position - currentPosition);
                return;
            }
            currentPosition += textLength;
            return;
        }
        if (node.nodeType !== Node.ELEMENT_NODE) {
            return;
        }
        const element = node;
        if (element.dataset.linkText &&
            element.dataset.linkUrl) {
            const tokenLength = serializeEditorLink(element.dataset.linkText, element.dataset.linkUrl).length;
            if (currentPosition + tokenLength >=
                position) {
                createRangeAfterElement(element);
                return;
            }
            currentPosition += tokenLength;
            return;
        }
        if (element.dataset.variable) {
            const tokenLength = `{{ ${element.dataset.variable} }}`.length;
            if (currentPosition + tokenLength >=
                position) {
                createRangeAfterElement(element);
                return;
            }
            currentPosition += tokenLength;
            return;
        }
        if (element.tagName === 'BR') {
            currentPosition += 1;
            return;
        }
        Array.from(element.childNodes).forEach(walk);
        if (element.tagName === 'DIV' ||
            element.tagName === 'P') {
            currentPosition += 1;
        }
    };
    Array.from(editor.childNodes).forEach(walk);
    if (!resultRange) {
        const range = document.createRange();
        range.selectNodeContents(editor);
        range.collapse(false);
        return range;
    }
    return resultRange;
};
